import React, { useContext, useEffect } from "react";
import { QuoteContext } from "./QuoteContext";
import Age from "./Age";
import Residency from "./Residency";
import Plans from "./Plans";
import Summary from "./Summary";
import Coverage from "./Coverage";
import Header from "./Header"




const QuoteForm = () => {
  const { step, formValues, resetQuoteForm  } = useContext(QuoteContext);

  const renderStep = () => {
    switch (step) {
      case 1:
        return <Coverage />;
      case 2:
        return <Age />;
      case 3:
        return <Residency />;
      case 4:
        return <Plans />;
      case 5:
        return <Summary />;
      default:
        return <Coverage />;
    }
  };

  // useEffect(() => {
  //   return () => {
  //     resetQuoteForm(); // Reset data when component unmounts
  //   };
  // }, []);

  console.log("Current form data:", formValues); // ✅ See collected data in console

  return (
    <div className="bg-[#001F3F] min-h-screen">
  <Header />
  <div className=""> {/* Add padding-top equal to the height of the Header */}
    {renderStep()}
  </div>
</div>
  );
};

export default QuoteForm;
